import { defineComponent as _defineComponent } from 'vue'
import { BaseText, ButtonPrimary } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  title: string;
  summaryText: string;
  buttonText: string;
  disableInput: boolean;
}
interface EmitEvents {
  (event: 'on-click-button'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutBar',
  props: {
    title: null,
    summaryText: null,
    buttonText: null,
    disableInput: { type: Boolean }
  },
  emits: ["on-click-button"],
  setup(__props: any) {




return { __sfc: true,BaseText, ButtonPrimary, NebraskaColors }
}

})